export default __webpack_public_path__ + "e76e1b2ad37f9533b094a7bc811397a5.png";